/* Progressive Shopify cart: native forms remain available without JavaScript. */
(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const dialog = () => document.getElementById('CartDialog');
  let lastTrigger;
  let mutationPending = false;
  const announce = text => { const status = document.querySelector('[data-global-status]'); if (status) status.textContent = text; };
  function openCart(trigger) {
    const panel = dialog();
    if (!panel || typeof panel.showModal !== 'function') return false;
    if (trigger) lastTrigger = trigger;
    if (!panel.open) panel.showModal();
    document.body.classList.add('modal-open');
    return true;
  }
  function closeCart() { dialog()?.close(); }
  function syncCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = count; });
  }
  async function parseResponse(response) {
    let data;
    try { data = await response.json(); } catch { throw new Error('No pudimos confirmar la respuesta. Revisa tu carrito antes de volver a intentar.'); }
    if (!response.ok) throw new Error(data.description || data.message || 'No pudimos actualizar el carrito. Intenta nuevamente.');
    return data;
  }
  function renderDrawer(html) {
    if (!html) return false;
    const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-content]');
    const current = dialog()?.querySelector('[data-drawer-content]');
    if (!incoming || !current) return false;
    current.replaceWith(incoming);
    syncCounts(incoming.dataset.count || 0);
    return true;
  }
  async function refreshDrawer() {
    const response = await fetch(root() + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
    const sections = await parseResponse(response);
    if (!renderDrawer(sections['cart-drawer'])) throw new Error('El carrito se actualizó. Ábrelo para revisar tu selección.');
  }
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-cart-open]');
    if (open) { if (openCart(open)) { event.preventDefault(); try { await refreshDrawer(); } catch { /* Server-rendered drawer still works; full cart remains linked. */ } } return; }
    if (event.target.closest('[data-cart-close]')) { closeCart(); return; }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); await changeQuantity(remove.dataset.key, 0); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ajax-product]');
    if (!form || event.submitter?.name !== 'add' || !dialog() || typeof dialog().showModal !== 'function') return;
    event.preventDefault();
    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-form-error]');
    if (mutationPending) return;
    mutationPending = true;
    const label = button.textContent;
    button.disabled = true; button.textContent = 'Preparando tu detalle…'; if (error) error.textContent = '';
    let added = false;
    try {
      const body = new FormData(form); body.append('sections', 'cart-drawer'); body.append('sections_url', root());
      const result = await parseResponse(await fetch(root() + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } }));
      added = true;
      if (!renderDrawer(result.sections?.['cart-drawer'])) {
        try { await refreshDrawer(); } catch { window.location.assign(root() + 'cart'); return; }
      }
      openCart(button); announce('Arreglo añadido al carrito.');
    } catch (err) {
      if (error) error.textContent = added ? 'Tu arreglo se añadió. Abre el carrito para confirmarlo antes de añadirlo otra vez.' : err.message;
      announce(err.message);
    } finally { button.disabled = false; button.textContent = label; mutationPending = false; }
  });
  async function changeQuantity(key, quantity) {
    const panel = dialog(); if (!panel || mutationPending || !Number.isInteger(quantity) || quantity < 0) return;
    mutationPending = true; panel.setAttribute('aria-busy', 'true');
    const error = panel.querySelector('[data-drawer-error]'); if (error) error.textContent = '';
    try {
      const result = await parseResponse(await fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: root() }) }));
      if (!renderDrawer(result.sections?.['cart-drawer'])) { try { await refreshDrawer(); } catch { window.location.assign(root() + 'cart'); return; } }
      syncCounts(result.item_count); announce('Carrito actualizado.');
    } catch (err) { if (error) error.textContent = err.message; announce(err.message); }
    finally { mutationPending = false; panel.removeAttribute('aria-busy'); }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]')) { changeQuantity(event.target.dataset.key, Number(event.target.value)); return; }
    if (!event.target.matches('[data-variant-select]')) return;
    const select = event.target; const option = select.selectedOptions[0]; const form = select.closest('form');
    const area = form.closest('.product-detail'); const price = area.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    const button = form.querySelector('[data-add-button]'); button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Agotado' : 'Añadir al carrito';
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open')); });
  const panel = dialog();
  if (panel) {
    panel.addEventListener('close', () => { document.body.classList.remove('modal-open'); if (lastTrigger?.isConnected) lastTrigger.focus(); });
    panel.addEventListener('click', event => { if (event.target !== panel) return; const rect = panel.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCart(); });
  }
})();
